

























import {Component, Vue, Watch, Provide} from 'vue-property-decorator';
import {State} from 'vuex-class';
import SureModalState from '@/store/modules/components/common/sureModal/types';

@Component({ })
export default class SureModal extends Vue {

    @State('sureModal') public sureModalState: SureModalState;

    @Provide() public $bvModal: any;

    private ok() {
        this.sureModalState.modal.action();
        this.close();
    }

    private close() {
        this.$bvModal.hide('sureModal');
    }

}
